import { render } from "./LoyerList.vue?vue&type=template&id=bbf35312"
import script from "./LoyerList.vue?vue&type=script&lang=js"
export * from "./LoyerList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__